module.exports = __webpack_public_path__ + "img/price-1.b8b02a19.png";